var map = {
	"./abTestCheckService.js": 133,
	"./abpService.js": 134,
	"./batchRequestsService.js": 135,
	"./cacheService.js": 136,
	"./chatDispatchService.js": 137,
	"./errorMessageService.js": 138,
	"./eventStreamService.js": 139,
	"./eventTrackerService.js": 140,
	"./friendsInfoService.js": 141,
	"./googleAnalyticsEventsService.js": 142,
	"./httpService.js": 143,
	"./hybridService.js": 144,
	"./imagesService.js": 145,
	"./localStorageService.js": 146,
	"./numericCodeService.js": 147,
	"./performanceService.js": 148,
	"./playGameService.js": 149,
	"./realtimeService.js": 150,
	"./regexService.js": 151,
	"./retryService.js": 152,
	"./urlService.js": 153,
	"./userService.js": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;